/** * 头部菜单 */
<template>
  <el-menu class="el-menu-demo" mode="horizontal" background-color="#fff" active-text-color="#fff" style="height: 60px">
    <div class="navConHeader">
      <div class="navConCenter">
        <div class="submenuName">
          <section class="sectionPLeft">
            <!-- <p>
              <img class="titleImg" v-if="user.avator == null || user.avator == ''" src="../assets/img/u8.png" />
              <img class="titleImg" v-else :src="user.avator" />
            </p> -->
            <p>
              <!-- <strong v-if="[0, 5, 7, 8, 20, 100, 14].includes(Number(applicationType))">{{ titleInfo[Number(applicationType)] }}</strong>
              <strong v-else-if="[10].includes(Number(applicationType))">{{ itemInfo.pcShowTitle }}</strong>
              <strong v-else-if="[12].includes(Number(applicationType))">{{
                loans.clientId > 20000 ? titleInfo[Number(applicationType)][0] : titleInfo[Number(applicationType)][1]
              }}</strong>
              <strong v-else>{{ itemInfo.applicationName }}管理系统</strong> -->
              <strong>{{ itemInfo.pcShowTitle ? itemInfo.pcShowTitle : itemInfo.applicationName + '管理系统' }}</strong>
            </p>
          </section>
        </div>
        <div class="navConlocation" v-if="[1, 2, 10].includes(Number(applicationType)) && info && info.authProvincesCityAreasName">
          <section>
            <img src="../assets/img/location.svg" />
            <strong>{{ info.authProvincesCityAreasName }}</strong>
          </section>
        </div>
        <div class="navConlocation" v-if="[7].includes(Number(applicationType)) && JDBM && JDBM.deptName">
          <section>
            <img src="../assets/img/location.svg" />
            <strong>{{ JDBM.deptName }}</strong>
          </section>
        </div>
        <div class="navConlocation" v-if="[12].includes(Number(applicationType)) && loans && loans.fullAreaName">
          <section>
            <img src="../assets/img/location.svg" />
            <strong>{{ loans.fullAreaName }}</strong>
          </section>
        </div>
        <div class="navConlocation" v-if="[14].includes(Number(applicationType)) && showAreaInfo">
          <section>
            <img src="../assets/img/location.svg" />
            <strong>{{ showAreaInfo }}</strong>
          </section>
        </div>
      </div>
      <div class="navConRight">
        <div class="submenu submenuSelect" v-if="applicationType == 1 && infoLocal" style="display: inline-block; float: left">
          <el-select @change="changeCitys" size="small" v-model="farmId" placeholder="选择牧场" style="min-width: 250px">
            <el-option v-for="item in infoLocal.farmItems" :key="item.farmId" :label="item.showName" :value="item.farmId">
              {{ item.showName }}
            </el-option>
          </el-select>
        </div>
        <div class="submenu submenuSelect" v-if="applicationType == 13" style="display: inline-block; float: left">
          <el-select size="small" v-model="livestockCurrent" placeholder="请选择畜只种类" style="width: 150px" @change="livestockChange">
            <el-option
              v-for="item in livestockListData"
              :key="item.livestockType"
              :value="item.livestockType"
              :label="item.livestockTypeDesc"
              >{{ item.livestockTypeDesc }}</el-option
            >
          </el-select>
        </div>
        <!-- <div class="unreadInformation">
          <section class="indexJust">
            <p>
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="none" version="1.1" width="30" height="30" viewBox="0 0 200 200">
                <defs>
                  <clipPath id="master_svg0_114_024"><rect x="0" y="0" width="200" height="200" rx="0"/></clipPath>
                </defs>
                <g clip-path="url(#master_svg0_114_024)"><g>
                <path d="M165.43001907348633,143.18321874999998L150.29301907348633,112.94921875C150.13701907348633,112.61721875,150.03901907348632,112.26561875,150.03901907348632,111.89451875L150.00001907348633,78.41801875C149.98001907348635,59.53121875,137.18701907348634,43.63281875,119.82421907348633,38.88671875L119.82421907348633,38.86721875C119.82421907348633,28.007808750000002,111.01561907348633,19.19921875,100.15621907348633,19.19921875C89.31641907348633,19.19921875,80.52731907348632,27.96874875,80.48831907348634,38.80861875C62.929719073486325,43.47651875,49.98041907348633,59.49221875,50.00001907348633,78.51561875L50.03901907348633,111.99221875C50.03901907348633,112.36331875,49.96091907348632,112.71481875,49.78511907348633,113.04691875L34.667969073486326,143.24221875C30.253909073486327,152.07021875,36.67968907348633,162.48021875,46.56251907348633,162.46121875L153.57401907348634,162.38321875C163.43701907348634,162.40221875,169.86301907348633,152.01121875,165.43001907348633,143.18321874999998ZM82.32421907348632,168.12521875C80.35151907348633,168.12521875,79.27731907348632,170.41021875,80.50781907348633,171.95321875C85.07811907348633,177.65621875,92.10941907348632,181.30821875,99.98051907348633,181.30821875C107.87111907348633,181.30821875,114.90231907348632,177.65621875,119.49221907348632,171.93321875C120.72261907348633,170.39021875,119.64841907348632,168.10521875,117.67581907348632,168.12521875L82.32421907348632,168.12521875Z" fill="#8BA1AB" fill-opacity="1"/></g></g>
              </svg>
            </p>
          </section>
          <div class="unreadNumber"><p><span>10</span></p></div>
        </div> -->
        <div class="submenuName submenuNameMargin" style="margin-top: 9px">
          <section>
            <p>
              <img class="titleImg" v-if="user.avator == null || user.avator == ''" src="../assets/img/u8.png" />
              <img class="titleImg" v-else :src="user.avator" />
            </p>
            <el-dropdown @command="handleCommand">
              <span class="el-dropdown-link" style="cursor: pointer">
                {{ info.userName || info.nickName }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="loginOut">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <p>
              <!-- <strong class="name">{{ info.userName || info.nickName }}</strong> -->
              <!-- ，你好! 欢迎来到
              <strong v-if="[0, 5, 7, 8, 20, 100].includes(Number(applicationType))">{{ titleInfo[Number(applicationType)] }}</strong>
              <strong v-else-if="[10].includes(Number(applicationType))">{{ itemInfo.pcShowTitle }}</strong>
              <strong v-else-if="[12].includes(Number(applicationType))">{{
                loans.clientId > 20000 ? titleInfo[Number(applicationType)][0] : titleInfo[Number(applicationType)][1]
              }}</strong>
              <strong v-else>{{ itemInfo.applicationName }}管理系统</strong> -->
            </p>
          </section>
        </div>
        <!-- <div class="exitTC indexJust" @click="exit()">
          <p>
            <i class="el-icon-switch-button" style="font-size: 24px"></i>
            退出
          </p>
        </div> -->
      </div>
    </div>
  </el-menu>
</template>
<script>
import { getUserFarmInfo } from '@/api/system';
import { beefUserInfo, LBUserInfo } from '@/views/breedingcattle/common/index.js';
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'navcon',
  data() {
    return {
      collapsed: true,
      imgshow: require('../assets/img/show.png'),
      imgsq: require('../assets/img/sq.png'),
      user: {},
      area: {},
      applicationType: 1,
      baseInfo: null,
      infoLocal: null,
      info: '',
      farmId: '',
      JDBM: '',
      itemInfo: null,
      loans: null,
      titleInfo: {
        0: '榆林市畜产品管理系统',
        5: '屠宰场管理系统',
        7: '见犊补母管理系统',
        8: '智慧养蜂管理系统',
        14: JSON.parse(localStorage.getItem('itemInfo')).pcShowTitle,
        12: ['金融助贷管理平台', '金融机构管理平台'],
        20: '疫病预警监测系统',
        100: '见犊补母设备申请'
      },
      showAreaInfo: beefUserInfo() ? beefUserInfo().showAreaInfo : '', //  肉牛项目区域名称
      // 获取种类列表
      livestockListData: LBUserInfo() ? LBUserInfo().currentLivestockType : [],
      livestockCurrent: ''
    };
  },
  computed: {
    ...mapState({
      currentLivestock: state => state.currentLivestock
    })
  },
  // 创建完毕状态(里面是操作)
  created() {
    this.loans = JSON.parse(localStorage.getItem('loans'));
    this.applicationType = localStorage.getItem('applicationType');
    if (this.applicationType == 7) {
      // 旧的
      // this.JDBM = JSON.parse(localStorage.getItem('deptList')).personOrg;
      // 新的 20241011
      this.JDBM = {};
      const userApplication_JDBM = JSON.parse(localStorage.getItem('userApplication_JDBM'));
      this.JDBM.deptName = userApplication_JDBM ? userApplication_JDBM.deptName : '';
    }
    this.user = JSON.parse(localStorage.getItem('userInfo'));
    this.info = JSON.parse(localStorage.getItem('info'));
    this.itemInfo = JSON.parse(localStorage.getItem('itemInfo'));
    if (this.applicationType == 1) {
      getUserFarmInfo({
        // 获取养殖场列表
        applicationType: this.applicationType
      }).then(res => {
        this.infoLocal = res.data.data[0];
        if (!localStorage.getItem('farmIdear')) {
          this.farmId = this.infoLocal.farmItems[0].farmId;
          localStorage.setItem('farmIdear', this.infoLocal.farmItems[0].farmId);
          localStorage.setItem('farmerUserId', this.infoLocal.farmItems[0].farmerUserId);
          localStorage.setItem('farmerUserName', this.infoLocal.farmItems[0].farmerUserName);
          localStorage.setItem('farmerUserPhone', this.infoLocal.farmItems[0].farmerUserPhone);
          localStorage.setItem('farmName', this.infoLocal.farmItems[0].farmName);
          localStorage.setItem('roleCode', this.infoLocal.farmItems[0].roleCode);
          localStorage.setItem('livestockTyper', this.infoLocal.farmItems[0].livestockType);
          localStorage.setItem('applicationId_getUser', this.infoLocal.farmItems[0].applicationId);
        } else {
          this.farmId = localStorage.getItem('farmIdear');
          this.infoLocal.farmItems.forEach(item => {
            if (item.farmId == this.farmId) {
              localStorage.setItem('livestockTyper', item.livestockType);
              localStorage.setItem('farmerUserId', item.farmerUserId);
              localStorage.setItem('farmerUserName', item.farmerUserName);
              localStorage.setItem('farmerUserPhone', item.farmerUserPhone);
              localStorage.setItem('farmName', item.farmName);
              localStorage.setItem('farmerUserId', item.farmerUserId);
              localStorage.setItem('roleCode', item.roleCode);
              localStorage.setItem('applicationId_getUser', item.applicationId);
            }
          });
        }
      });
    }

    // if (this.infoLocal.farmList.length > 0) {
    //   if (localStorage.getItem('farmIdear')) {
    //     this.farmId = localStorage.getItem('farmIdear');
    //   } else {
    //     this.farmId = this.infoLocal.farmList[0].userCertFileId;
    //     localStorage.setItem('farmIdear', this.infoLocal.farmList[0].userCertFileId);
    //     localStorage.setItem('livestockTyper', this.infoLocal.farmList[0].livestockType);
    //   }
    // }

    if (this.user == null) {
      this.$store.commit('logout', 'false');
      localStorage.removeItem('token');
      localStorage.removeItem('zizhouuserInfo');
      localStorage.removeItem('userPhone');
      localStorage.removeItem('userInfo');
      localStorage.removeItem('farmIdear');
      localStorage.removeItem('farmerUserId');
      localStorage.removeItem('farmIdearName');
      localStorage.removeItem('permissiontable');
      localStorage.removeItem('applicationId_getUser');
      this.$router.push({ path: '/home' });
      this.$message({
        type: 'warning',
        message: '此账号已退出登录，请重新登陆!'
      });
    }
  },
  methods: {
    ...mapMutations(['mutCurrentLivestock', 'mutLivestockListStroe']),
    livestockChange() {
      this.mutCurrentLivestock(this.livestockCurrent);
    },
    // 切换牧场
    changeCitys(e) {
      this.farmId = e;
      localStorage.setItem('farmIdear', e);
      this.infoLocal.farmItems.forEach((item, i) => {
        if (item.farmId == e) {
          localStorage.setItem('livestockTyper', item.livestockType);
          localStorage.setItem('farmerUserId', item.farmerUserId);
          localStorage.setItem('farmerUserName', item.farmerUserName);
          localStorage.setItem('farmerUserPhone', item.farmerUserPhone);
          localStorage.setItem('farmName', item.farmName);
          localStorage.setItem('farmerUserId', item.farmerUserId);
          localStorage.setItem('roleCode', item.roleCode);
          localStorage.setItem('applicationId_getUser', item.applicationId);
        }
      });
      //
      location.reload();
    },
    handleCommand(type) {
      if (type === 'loginOut') this.exit();
    },
    // 退出登录
    exit() {
      const that = this;
      this.$confirm('退出登录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          setTimeout(() => {
            window.open('about:blank', '_self').close();
            that.mutCurrentLivestock('');
          }, 500);
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
    }
  },
  watch: {
    currentLivestock: {
      handler: function (val) {
        this.livestockCurrent = val;
      },
      deep: true,
      immediate: true
    }
  }
};
</script>
<style scoped>
/deep/.el-menu--horizontal > .el-submenu .el-submenu__icon-arrow {
  margin-top: 0;
}

.el-menu-demo {
  /* position: fixed; */
  /* top: 0;
  left: 0; */
  /* width: 100%;
  z-index: 999; */
}
.titleT {
  color: #333333;
  font-size: 24px;
  /* margin-left: 15px; */
  font-weight: bold;
  display: inline-block;
  vertical-align: middle;
  height: 60px;
  line-height: 60px;
  font-family: 'Arial Negreta', 'Arial Normal', 'Arial';
}
.areaTitle {
  margin-left: 10px;
  margin-top: 15px;
  height: 30px;
  background-color: rgba(235, 235, 235, 1);
  border-radius: 15px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  font-size: 14px;
  color: #666666;
  line-height: 30px;
  padding: 0 10px;
}
.areaTitle img {
  width: 14px;
  height: 14px;
  opacity: 0.6;
  vertical-align: middle;
}
.titleImg {
  width: 28px;
  height: 28px;
  border-radius: 50%;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
}
.buttonimg {
  height: 60px;
  background-color: transparent;
  border: none;
}

.logobox img {
  width: 120px;
  height: 30px;
  margin: 15px 20px 0;
}
/deep/ .el-menu-item {
  min-height: 40px !important;
}
</style>

<style lang="scss">
@import '../assets/scss/index.scss';

.el-dropdown {
  font-size: $fontSize;
  color: $fontColor333;
}
.el-icon--right {
  margin-left: 10px;
}

.submenuSelect {
  .el-input__inner {
    // border-radius: 20px;
    // border: none;
    // background: $backColor;
  }
}
.exitTC {
  float: right;
  width: 32px;
  height: 32px;
  margin: 15px 15px 0 10px;
  cursor: pointer;
  &:hover {
    background: $backColor;
    border-radius: 4px;
  }
  i {
    color: $mainColor;
  }
}
.el-menu.el-menu--horizontal {
  border-bottom: none !important;
}

.submenuName {
  height: 30px;
  // margin-top: 18px;
  display: inline-block;
  position: relative;
  top: 9px;
  &.submenuNameMargin {
    margin-right: 10px;
    // padding-right: 24px;
    position: relative;
  }
  section {
    display: flex;
    padding-left: 15px;
    line-height: 28px;
    color: #686868;
    &.sectionPLeft {
      padding-left: 0px;
      p {
        font-size: 22px;
        padding-top: 8px;
        letter-spacing: 2px;
        color: $fontColor333;
        strong {
          font-weight: 700;
        }
      }
    }
    strong {
      font-weight: normal;
      &.name {
        font-weight: bold;
        color: $mainColor;
        font-size: $fontSize;
      }
    }
    p {
      font-size: $fontSize;
      padding: 0;
      margin: 0;
      &:first-of-type {
        margin-right: 10px;
      }
    }
  }
}

.navConHeader {
  display: flex;
  height: 60px;
  line-height: 60px;
  padding: 0 20px;
  .navConLogo {
    section {
      padding: 15px;
      width: 120px;
      height: 30px;
      img {
        width: 100%;
        height: auto;
      }
    }
  }
  .navConCenter {
    flex: 1;
    display: flex;
    .navConlocation {
      padding-top: 15px;
      section {
        background: $backLogoIcon;
        color: $logoIcon_text;
        padding: 5px 10px;
        border-radius: 20px;
        line-height: 22px;
        font-size: $fontSize;
        strong {
          font-weight: normal;
        }
        img {
          width: 16px;
          height: auto;
          position: relative;
          top: 3px;
        }
      }
    }
  }
}

.unreadInformation {
  margin-top: 16px;
  float: left;
  margin-left: 15px;
  position: relative;
  cursor: pointer;
  section {
    width: 32px;
    height: 32px;
  }
  .unreadNumber {
    background: $abnormalColor;
    position: absolute;
    top: -3px;
    right: -3px;
    font-size: $fontSize13;
    color: white;
    padding: 2px 3px;
    border-radius: 20px;
  }
}
</style>

<style lang="scss">
.indexJust {
  display: flex;
  display: -ms-flexbox;
  -webkit-display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/navcon.vue